import request from '@/utils/request'

// 获取完成回访表单数据
export function getCompleteFollowupForm(params) {
  return request({
    url: '/health-doctor-assistant/active-followup/complete-remark-suggest',
    method: 'get',
    params
  })
}

// 主动回访池分页
export function getActiveFollowupPage(data) {
  return request({
    url: '/health-doctor-assistant/active-followup/page',
    method: 'post',
    data
  })
}

// 获取健管（DA）列表（支持搜索）
export function getDaList(params) {
  return request({
    url: '/health-doctor-assistant/active-followup/da-list',
    method: 'get',
    params
  })
}

// 获取部门树
export function getDepartmentTree(params) {
  return request({
    url: '/health-doctor-assistant/active-followup/department-tree',
    method: 'get',
    params
  })
}

// 移除主动回访记录
export function removeActiveFollowup(data) {
  return request({
    url: '/health-doctor-assistant/active-followup/remove',
    method: 'post',
    data
  })
}

// 查询主动回访路径
export function getRevisitPath(params) {
  return request({
    url: '/health-doctor-assistant/active-followup/path',
    method: 'get',
    params
  })
}
export const checkPatientWorkOrder = params => {
  return request({
    url: '/health-doctor-assistant/active-followup/check-patient-work-order',
    method: 'post',
    data: params
  })
}

// 完成回访
export function completeActiveFollowup(data) {
  return request({
    url: '/health-doctor-assistant/active-followup/complete',
    method: 'post',
    data
  })
}

// 补充下次回访时间
export function fillNextFollowupTime(data) {
  return request({
    url: '/health-doctor-assistant/active-followup/next-followup-time',
    method: 'post',
    data
  })
}

// 查询患者完成回访备注
export function getCompleteRemarks(params) {
  return request({
    url: '/health-doctor-assistant/active-followup/complete-remarks',
    method: 'get',
    params
  })
}

// 查询下次回访冲突提示，按医患维度只返回最近一条未关闭提示
export function getNextFollowupNotices(params) {
  return request({
    url: '/health-doctor-assistant/active-followup/next-followup-notices',
    method: 'get',
    params
  })
}

// 查询下次回访冲突提示，按医患维度只返回最近一条未关闭提示
export function closeNotices(params) {
  return request({
    url: '/health-doctor-assistant/active-followup/next-followup-notices/close',
    method: 'get',
    params
  })
}

// ==================== 拨打前跨回访池校验 ====================
// 拨打前校验患者是否在其他健管回访池中（非结束态）
// 入参 { ucPatientId, ucDoctorId? }
//   ucDoctorId：调用方已经确定医生时才传（医生下钻患者池、患者档案下方为一对一关系），没有就不传
// 出参 data {
//   promptType,     // 0 无提示 / 1 跨回访池确认 / 2 自动加入回访池确认（两种提示互斥）
//   message,        // 提示文案，前端直接展示，不要自己拼
//   needConfirm,    // 等价 promptType=1，兼容旧前端
//   canJoin,        // 当前登录健管是否还能自己加入
//   bindDoctorType, // 0 无绑定医生 / 1 单个 / 2 多个；跨池命中为 0，传了 ucDoctorId 固定为 1
//   doctors,        // [{ ucDoctorId, doctorName }]，跨池命中为空
//   patientName, targetDaName, targetDaNames, targetDaUcUserId, targetFollowupId
// }
// 注意：本接口只做校验，不创建回访任务
// 确认跨池拨打后的埋点随拨打参数（sourcePage/crossPoolConfirmed/crossPoolTargetFollowupId）经
// /health-doctor-assistant/tccc/record-save-before-call 上报，无需单独的埋点接口
export function checkCrossPoolCall(data) {
  return request({
    url: '/health-doctor-assistant/active-followup/check-cross-pool-call',
    method: 'post',
    data
  })
}
